<ng-container *transloco="let convert;">
  @if (vm$ | async; as vm) {
    <section class="container">
      @switch (vm.requestState) {
        @case ('NO_RESULTS') {
          <section role="alert">
            <h2 class="text-center no-offer mt-1" tabindex="-1">{{convert('sellModule.offers.offersShell.textCurrentlyOffer')}}</h2>
          </section>
        }
        @case ('LOADED') {
          <section
            [attr.aria-label]="convert('sellModule.offers.offersShell.textInventoryItem')"
            data-track-region="Manage Vehicles"
            >
            @for (offer of vm.offers; track offer; let i = $index) {
              <lib-offer
                [index]="i"
                [offer]="offer"
                [inventoryItem]="vm.inventoryItem"
                [tenantName]="vm.tenantName"
                (getHistory)="onGetHistory($event)"
                [showBuyerUserNameToSeller] = "showBuyerUserNameToSeller"
              ></lib-offer>
            }
          </section>
        }
      }
    </section>
  }
</ng-container>
